import './styles/App.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import { ThemeProvider } from 'styled-components';
import Home from './pages/passengers/home';
import HomeAdmin from './pages/admin/home';
import HomeSeller from './pages/sellers/home';
import AccessSeller from './pages/sellers/access';
import theme from './styles/theme';
import { SellerContext } from './context/seller';
import Access from './pages/passengers/access';
import AccessAdmin from './pages/admin/access';
import { AdminContext } from './context/admin';
import Me from './pages/sellers/me';
import AddPassengers from './pages/admin/addPassengers';
import { PassengerContext } from './context/passenger';
import { useGlobal } from './context/global';
import Message from './components/common/Message';
import Loader from './components/common/Loader';

function App() {
  const {message, isLoading} = useGlobal()
  
  return (
    <ThemeProvider theme={theme}>
      <BrowserRouter>
        <ContextProvider>
          <Routes>
            <Route path='/' element={<Home/>}/>
            <Route path='/access' element={<Access/>}/>
            <Route path='/seller' element={<HomeSeller/>}/>
            <Route path='/seller/access' element={<AccessSeller/>}/>
            <Route path='/seller/me' element={<Me/>}/>
            <Route path='/admin' element={<HomeAdmin/>}/>
            <Route path='/admin/access' element={<AccessAdmin/>}/>
            <Route path='/admin/addPassengers' element={<AddPassengers/>}/>
          </Routes>
          {message && <Message content={message.content} type={message.type} />}
          {isLoading && <Loader />}
        </ContextProvider>
      </BrowserRouter>
    </ThemeProvider>
  );
}

// Create a wrapper component that provides the appropriate context based on route
function ContextProvider({ children }: { children: React.ReactNode }) {
  const location = window.location.pathname;
  
  // Determine which context(s) to provide based on the current route
  const isAdminRoute = location.startsWith('/admin');
  const isSellerRoute = location.startsWith('/seller');
  const isPassengerRoute = !isAdminRoute && !isSellerRoute;
  
  // For admin routes, only provide AdminContext
  if (isAdminRoute) {
    return (
      <AdminContext>
        {children}
      </AdminContext>
    );
  }
  
  // For seller routes, only provide SellerContext
  if (isSellerRoute) {
    return (
      <SellerContext>
        {children}
      </SellerContext>
    );
  }
  
  // For passenger routes, only provide PassengerContext
  if (isPassengerRoute) {
    return (
      <PassengerContext>
        {children}
      </PassengerContext>
    );
  }

  return <>{children}</>;
}

export default App;